import { FunctionalComponent, h } from 'preact'
import Chip from '../design-system-components/chip'
import ListGroup from '../design-system-components/list-group'

export interface GroupTagsProps {
  tags: string[]
  selectedTags: string[]
  onTagClick: (tagLabel: string) => void
}

export const GroupTags: FunctionalComponent<GroupTagsProps> = ({
  tags,
  selectedTags,
  onTagClick
}) => {
  if (tags.length === 0) {
    return null
  }
  return (
    <ListGroup gutterBottom spacing={DesignTokens.SpacingEnum.S8}>
      {tags.map((tagLabel) => (
        <Chip
          key={tagLabel}
          type='button'
          active={selectedTags.includes(tagLabel)}
          className='qa-tag-pill'
          onClick={(_) => onTagClick(tagLabel)}
        >
          {tagLabel}
        </Chip>
      ))}
    </ListGroup>
  )
}
